import $ from 'jquery';

const viewMore = $('.view-more-button');
viewMore.on('click', function (e) {
  e.preventDefault();
  $(this).hide().addClass('hidden');
  $('.related-content .card:hidden').css('display', 'flex').hide().fadeIn();
});
